module.exports = __webpack_public_path__ + "6be20f6e54963f31bdf9e33f9e4d6380.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/LeagueGothic/leaguegothic-condensed-regular-webfont.eot
// module id = 436
// module chunks = 0